/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import { Route, Redirect } from "react-router-dom";
import { DASHBOARD } from "../constants/routes";
import { isAdminUser } from "./user-session";
import { Box, Grid } from "@material-ui/core";
import { ContentSection, Header, SidebarSection } from "../components";
import Menu from "../containers/menu";
import { useCSRValue } from "../context";

export interface AuthProtectRouteProps {
  user: any;
  [extraProps: string]: any;
}

const AdminProtectedRoute = ({
  user,
  children,
  ...rest
}: AuthProtectRouteProps) => {
  const { csr } = useCSRValue();
  const isAdmin = isAdminUser();

  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!user || !user.userLoggedIn) {
          return (
            <Redirect
              to={{
                pathname: DASHBOARD,
                state: { from: location },
              }}
            />
          );
        }

        if (!isAdmin) {
          return (
            <Redirect
              to={{
                pathname: DASHBOARD,
                state: { from: location },
              }}
            />
          );
        }

        if (user.userLoggedIn && isAdmin) {
          return (
            <Box>
              <Box>
                <Header shopAs={false} username={csr && csr.userLoggedIn} />
              </Box>

              <Grid
                container
                alignItems="stretch"
                className="min-content-height">
                <SidebarSection>
                  <Menu />
                </SidebarSection>
                <ContentSection>{children}</ContentSection>
              </Grid>
            </Box>
          );
        }

        return null;
      }}
    />
  );
};

export default AdminProtectedRoute;
